import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12 max-w-[600px] mx-auto">
          探索糖心视频、黑桃视频、妖精视频、桃花视频热门专题内容
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200/60"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 text-xs font-semibold text-background-50 bg-accent-500/90 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {carouselData.slice(3, 5).map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200/60 flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-[180px] lg:w-[220px] flex-shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2.5 py-0.5 text-xs font-semibold text-background-50 bg-accent-500/90 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col justify-center">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}